module.exports = __webpack_public_path__ + "static/media/phone-only.25eb352.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/videos/phone-only.webm
// module id = QklB
// module chunks = 0